export const environment = {
  production: true,
  redirectIfNotInIframe: true,
};
